import { combineReducers } from "redux";
import compile from "./compile";
import auth from "./auth";
import problem from "./problem";
import profile from "./profile";

export default combineReducers({
  auth,
  compile,
  problem,
  profile,
});
